import styled from 'styled-components'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const Section = styled.section`
  --toggle-spacing: 1.6rem;

  ${mq.medium} {
    --toggle-spacing: 2.4rem;
  }

  margin: 6rem 0;
`

export const Title = styled.h1`
  margin: 0 0 2rem;
  font: 400 2.5rem ${theme.fonts.headings};
  text-transform: uppercase;

  ${mq.medium} {
    font-size: 4.5rem;
  }
`

export const Count = styled.span`
  display: block;
  position: absolute;
  top: 0;
  left: 100%;
  margin: 0 0.2em;
  font-size: 0.54em;
  font-weight: bold;
  color: #d12430;
`

export const People = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 1fr;
  gap: 1rem;
  padding: 0;
  margin: 4rem 0;
  font-size: 1.6rem;
  list-style: none;

  @media (min-width: ${450 / 16}em) {
    grid-template-columns: repeat(auto-fill, minmax(10em, 1fr));
  }

  ${mq.medium} {
    font-size: 2.2rem;
  }

  li {
    display: flex;
    flex-direction: column;
    border: 2px solid var(--color);
    color: var(--color);
    font-weight: 200;
    text-align: center;
  }

  a {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-grow: 1;
    padding: 0.5em 1em;
    color: inherit;
    text-decoration: none;
    transition: background-color 0.3s;

    &:hover,
    &:focus {
      color: inherit;
      background-color: #00000011;
    }
  }

  span {
    display: block;
  }
`
